import React, { ReactElement } from "react";
import HubOrderList from "../../../components/Hubs/Orders";
import Layout from "../../../components/layout";

const HubOrderPage = (): ReactElement => {
  return (
    <Layout>
      <HubOrderList />
    </Layout>
  );
};

export default HubOrderPage;
